const { Component, render } = wp.element;
import Railway from './railway/index.jsx';
if( document.getElementById('railway') ){
    render(
        <Railway />,
        document.getElementById('railway')
    )
}
import School from './school/index.jsx';
if( document.getElementById('student_school') ){
    render(
        <School />,
        document.getElementById('student_school')
    )
}

